import React from "react"
import PropTypes from "prop-types"
import muiThemeable from "material-ui/styles/muiThemeable"
import { Row, Col } from "react-bootstrap"
import VanIcon from "components/commons/svg-icons/Basset/van"
import { airport } from "utils/flightsHelper"
import { withTranslation } from "react-i18next"

class LegChangeAirport extends React.PureComponent {
  render() {
    const { leg, nextLeg, muiTheme, t } = this.props

    if (!nextLeg || leg.destination.code === nextLeg.origin.code) {
      return null
    }

    return (
      <Row style={{ paddingTop: 8 }}>
        <Col xs={1} style={{ textAlign: "center" }}>
          <p>
            <VanIcon style={{ fill: muiTheme.palette.highlightedColor }} size={20} />
          </p>
        </Col>
        <Col xs={11} sm={11} md={8}>
          <p>
            <strong style={{ color: muiTheme.palette.highlightedColor }}>{t("Cambio de Aeropuerto")}</strong>
            <br />
            <span style={{ fontSize: 13 }}>
              {t("de {{changeFrom}} a {{changeTo}}", {
                changeFrom: `${airport(leg.destination.name)} (${leg.destination.code})`,
                changeTo: `${airport(nextLeg.origin.name)} (${nextLeg.origin.code})`
              })}
            </span>
            <br />
            <span style={{ fontSize: 12, color: "#9b9b9b" }}>
              {t("*El costo de traslado entre aeropuertos no está incluido en la tarifa")}
            </span>
          </p>
        </Col>
      </Row>
    )
  }
}

export default muiThemeable()(withTranslation()(LegChangeAirport))

LegChangeAirport.propTypes = {
  leg: PropTypes.object.isRequired,
  nextLeg: PropTypes.object
}
